<template>
  <div
    ref="line"
    :class="{ [$style.lineWrapper]: true, [className]: true, [$style.vertical]: vertical }"
    :style="{ [styleKey]: length + 'px', transform }"
  >
    <div :class="$style.text">{{ title }}</div>
    <div :class="$style.line">
      <div :class="$style.arrow"></div>
      <div :class="$style.lineBody"></div>
      <div :class="$style.arrow"></div>
    </div>
  </div>
</template>


<script>
import interact from 'interactjs'

export default {
  props: ['title', 'vertical', 'length', 'left', 'top'],
  data() {
    return {
      transform: ''
    }
  },
  computed: {
    className() {
      return 'l' + this._uid;
    },
    styleKey() {
      return this.vertical ? 'height' : 'width';
    }
  },
  methods: {
    onMove(event) {
      const target = event.target
      const x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
      const y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

      target.style.webkitTransform =
        target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';

      target.setAttribute('data-x', x);
      target.setAttribute('data-y', y);
      this.$emit('resize', {
        length: event.rect[this.styleKey],
        left: x,
        top: y,
      })

    },
    onResizeMove(event) {
      var target = event.target,
            x = (parseFloat(target.getAttribute('data-x')) || 0),
            y = (parseFloat(target.getAttribute('data-y')) || 0);

        this.$emit('resize', {
          length: event.rect[this.styleKey],
          left: x,
          top: y,
        })


        // translate when resizing from top or left edges
        x += event.deltaRect.left;
        y += event.deltaRect.top;

        this.transform = 'translate(' + x + 'px,' + y + 'px)';

        target.setAttribute('data-x', x);
        target.setAttribute('data-y', y);
    }
  },
  mounted() {
    const el = this.$refs.line
    el.style.webkitTransform =
    el.style.transform = 'translate(' + this.left + 'px, ' + this.top + 'px)';

    interact('.l' + this._uid)
      .draggable({
        onmove: this.onMove,
        restrict: {
          restriction: 'parent',
          elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
        },
      })
      .resizable({
        edges: {
          left: !this.vertical, right: !this.vertical,
          bottom: this.vertical, top: this.vertical
        },
        restrictEdges: {
          outer: 'parent',
          endOnly: true,
        },
        inertia: true,
      })
      .on('resizemove', this.onResizeMove);
  }
}
</script>

<style lang="scss" module>
.lineWrapper {
  width: 200px;
  position: absolute;
  top: 0;
  left: 0;
  -ms-touch-action: none;
  touch-action: none;

  &.vertical {
    width: auto;
    height: 200px;
  }
}

.line {
  width: 100%;
  height: 20px;
  user-select: none;

  display: flex;
  align-items: center;

  .vertical & {
    width: 20px;
    height: 100%;
    flex-direction: column;
  }
}

.arrow {
  flex-grow: 0;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-right: 20px solid rgba(255, 238, 0, .5);
  border-bottom: 10px solid transparent;

  .lineBody ~ & {
    transform: rotate(180deg);
  }

  .vertical & {
    transform: rotate(90deg);
  }

  .vertical .lineBody ~ & {
    transform: rotate(270deg);
  }
}

.lineBody {
  background-color: rgba(255, 238, 0, .5);
  flex-shrink: 1;
  height: 10px;
  width: 100%;

  .vertical & {
    height: 100%;
    width: 10px;
  }
}

.text {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -100%);
  white-space: nowrap;
  background-color: rgba(255, 238, 230, .5);
  font-weight: 900;

  .vertical & {
    writing-mode: vertical-rl;
    text-orientation: mixed;
    top: 50%;
    left: auto;
    right: 0;
    transform: translate(100%, -50%);
  }
}
</style>
